<template>
  <div>
    <notifications group="notification" position="bottom right" />
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b card-stretch">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title">
              <span class="card-label font-weight-bolder text-dark"
                >Archived Products</span
              >
            </h3>
          </div>
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table
                    class="table table-head-custom table-head-bg table-vertical-center"
                  >
                    <thead>
                      <tr class="bg-gray-100 text-left">
                        <th style="min-width: 250px" class="pl-7">
                          <span>Name</span>
                        </th>
                        <th style="min-width: 130px">
                          <span>Price</span>
                        </th>
                        <th style="min-width: 120px">Brand</th>
                        <th style="min-width: 110px">Root Category</th>
                        <th style="min-width: 110px">Category</th>
                        <th style="min-width: 110px" class="pr-7 text-right">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(product, key) in products" :key="key">
                        <td
                          class="pl-0 py-4"
                          :class="{ 'border-top-0': key === 0 }"
                        >
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-50 symbol-light mr-4">
                              <img
                                v-if="
                                  product.featuredImage.hasOwnProperty('src')
                                "
                                :src="
                                  appPath +
                                  '/media/cache/resolve/50x50/' +
                                  product.featuredImage.src
                                "
                                class="h-75 align-self-end"
                                alt=""
                              />
                              <div v-else class="symbol-label"></div>
                            </div>
                            <div>
                              <router-link
                                :to="'/products/edit/' + product.id"
                                class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                >{{ product.name }}</router-link
                              >
                              <span class="text-muted font-weight-bold d-block"
                                >SKU: {{ product.sku }}</span
                              >
                            </div>
                          </div>
                        </td>
                        <td :class="{ 'border-top-0': key === 0 }">
                          <span
                            class="text-dark-75 font-weight-bolder d-block font-size-lg"
                            >{{ product.price }} <span>€</span></span
                          >
                          <span
                            v-if="product.specialPrice"
                            class="text-muted font-weight-bold"
                            >{{ product.specialPrice }} <span>€</span></span
                          >
                        </td>
                        <td :class="{ 'border-top-0': key === 0 }">
                          <span
                            v-if="product.brand"
                            class="text-dark-75 font-weight-bolder d-block font-size-lg"
                            >{{ product.brand.name }}</span
                          >
                        </td>
                        <td :class="{ 'border-top-0': key === 0 }">
                          <span
                            v-if="product.category"
                            class="label label-lg label-light-danger label-inline"
                            >{{ product.category.root.title }}</span
                          >
                        </td>
                        <td :class="{ 'border-top-0': key === 0 }">
                          <span
                            v-if="product.category"
                            class="label label-lg label-light-primary label-inline"
                            >{{ product.category.title }}</span
                          >
                        </td>
                        <td
                          class="pr-0 text-right"
                          :class="{ 'border-top-0': key === 0 }"
                        >
                          <a
                            v-if="product.category"
                            :href="`${appPath}/proizvodi/${product.category.root.slug}/${product.category.slug}/${product.slug}`"
                            class="btn btn-icon btn-light btn-hover-light-primary btn-sm mr-3"
                            target="_blank"
                          >
                            <span class="svg-icon svg-icon-md">
                              <inline-svg
                                src="media/svg/icons/General/Visible.svg"
                              />
                            </span>
                          </a>
                          <router-link
                            :to="'/products/edit/' + product.id"
                            class="btn btn-icon btn-light btn-hover-light-primary btn-sm mr-3"
                          >
                            <span class="svg-icon svg-icon-md">
                              <inline-svg
                                src="media/svg/icons/Communication/Write.svg"
                              />
                            </span>
                          </router-link>
                          <button
                            @click="removeProduct(product.id)"
                            class="btn btn-icon btn-light btn-hover-light-primary btn-sm"
                          >
                            <span class="svg-icon svg-icon-md">
                              <inline-svg
                                src="media/svg/icons/General/Trash.svg"
                              />
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="!isProductsLoaded" class="col-md-12 text-center mt-5">
                <b-spinner variant="primary" type="grow"></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'

export default {
  name: 'ArchivedProducts',
  data() {
    return {
      products: [],
      appPath: process.env.VUE_APP_ROUTE_API_URL,
      isProductsLoaded: false,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Archived Products', route: '/products/archived' },
    ])

    ApiService.get2('/products?isArchived=true').then(({ data }) => {
      this.products = data['hydra:member']
      this.isProductsLoaded = true
    })
  },
  methods: {},
}
</script>
